var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"width":"96px"},attrs:{"color":"primary","rounded":""},on:{"click":function($event){return _vm.$createOnClick({ donate: _vm.onClick })}}},[_vm._v("Don")])}
var staticRenderFns = []

export { render, staticRenderFns }